import { graphql } from 'gatsby';

export const TextGridSliceFragment = graphql`
    fragment PrismicTextGridFragment on PRISMIC_PageBodyText_grid {
        type
        primary {
            text_grid_number_of_columns
            grid_title
        }
        fields {
            text_grid_title
            text_grid_description
            text_grid_logo
            text_grid_full_image
            text_grid_full_imageSharp {
                ...FluidImageFragment
            }
        }
    }
`;
